export function limparFeedBack(){
    return {
        type: 'FEEDBACK_LIMPAR'
    }
}

export function setFeedBack({
    pageTitle = 'Meu INSS',
    icon, 
    title, 
    description, 
    primaryAction, 
    primaryActionLabel, 
    secondaryAction,
    secondaryActionLabel, 
    noAction
}){
    return {
        type: 'SET_FEEDBACK',
        payload: {
            pageTitle,
            icon, 
            title, 
            description, 
            primaryAction, 
            primaryActionLabel, 
            secondaryAction,
            secondaryActionLabel, 
            noAction
        }
    }
}

export function triggerAction(id) {
    return {
        type: 'FEEDBACK_TRIGGER_ACTION',
        payload: id
    }
}